"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSecondaryLanguageFromPathname = exports.getSecondaryLanguageFromPathname = exports.addSecondaryLanguageToPathname = void 0;
const getSecondaryLanguageFromPathname = pathname => pathname.match(/^\/([a-z]{2})\//)?.[0].replaceAll('/', '');
exports.getSecondaryLanguageFromPathname = getSecondaryLanguageFromPathname;
const removeSecondaryLanguageFromPathname = pathname => {
  const secondaryLanguage = getSecondaryLanguageFromPathname(pathname);
  return secondaryLanguage ? pathname.replace(`/${secondaryLanguage}`, '') : pathname;
};
exports.removeSecondaryLanguageFromPathname = removeSecondaryLanguageFromPathname;
const addSecondaryLanguageToPathname = (pathname, currentPathname) => {
  const secondaryLanguage = getSecondaryLanguageFromPathname(currentPathname);
  if (secondaryLanguage) {
    return pathname.replace(/^\//, `/${secondaryLanguage}/`);
  }
  return pathname;
};
exports.addSecondaryLanguageToPathname = addSecondaryLanguageToPathname;
